import { render, staticRenderFns } from "./exa-order-popup.vue?vue&type=template&id=044af8ec&scoped=true&"
import script from "./exa-order-popup.vue?vue&type=script&lang=js&"
export * from "./exa-order-popup.vue?vue&type=script&lang=js&"
import style0 from "./exa-order-popup.vue?vue&type=style&index=0&id=044af8ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044af8ec",
  null
  
)

export default component.exports